const services = [
    {
        title: "AI-Driven Storyboarding",
        description:
            "Generate cinematic storyboards in minutes using natural language prompts and scene pre-visualization powered by AI.",
        image: "/images/storyboard.png",
    },
    {
        title: "Virtual Production",
        description:
            "Leverage AI in Unreal Engine and 3D environments to build sets, characters, and worlds on the fly.",
        image: "/images/virtual-production.png",
    },
    {
        title: "Post-Production Enhancement",
        description:
            "Color grading, editing, and VFX acceleration using deep learning algorithms.",
        image: "/images/post-production.png",
    },
    {
        title: "AI Voice & SFX Synthesis",
        description:
            "Generate stunning voiceovers and sci-fi effects using neural models and text-to-sound synthesis.",
        image: "/images/voice-sfx.png",
    },
    {
        title: "Concept-to-Screen Consulting",
        description:
            "From script to final cut — AI-powered creative consulting tailored to your brand.",
        image: "/images/consulting.png",
    },
];

export default services;
